/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CloudProviderEnum } from './cloudProviderEnum';


export interface ProviderComponentCloudProviderInfo { 
    /**
     * Provider cloud account id
     */
    account_id?: string;
    /**
     * Availability zone
     */
    availability_zone?: string;
    provider: CloudProviderEnum;
    /**
     * Region
     */
    region: string;
}
export namespace ProviderComponentCloudProviderInfo {
}


